import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from 'i18next';

import wentWrongImage from '@assets/images/something-went-wrong.svg';
import { errorLogger } from '@utils/axios/ErrorLogging';

type RfpErrorBoundaryProps = {
  children?: ReactNode;
};

type RfpErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Catches render crashes, logs via errorLogger, and shows a Trust Center fallback screen.
 */
class RfpErrorBoundary extends Component<RfpErrorBoundaryProps, RfpErrorBoundaryState> {
  state: RfpErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RfpErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    void errorLogger(error, false, info.componentStack || undefined);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          data-qa='ERROR_BOUNDARY_FALLBACK'
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#fafafa',
            padding: 24,
            textAlign: 'center',
            boxSizing: 'border-box'
          }}>
          <img src={wentWrongImage} alt='Something went wrong' width={250} height={200} style={{ marginBottom: 35 }} />
          <div style={{ maxWidth: 480, fontSize: 16, lineHeight: 1.5, color: '#333' }}>
            {i18n.t('TRUST_CENTER_TEMPORARILY_UNAVAILABLE_MSG', {
              ns: 'translations'
            })}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RfpErrorBoundary;
